import { api } from './_client';
import type { FlightType } from '../../types/api';

export const flightTypesApi = {
  // Get all flight types
  async getFlightTypes(serialNumberFilter?: string): Promise<FlightType[]> {
    const params = new URLSearchParams();
    if (serialNumberFilter) params.append('serial_number_filter', serialNumberFilter);

    const url = `/flight-types${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await api.get<FlightType[]>(url);
    return response.data;
  },

  // Get flight types from database (rich objects with colors)
  async getFlightTypesFromDB(): Promise<FlightType[]> {
    const response = await api.get('/flight-types');
    return response.data;
  },
};
